import * as Yup from "yup";
import checkout from "./form";

import Mnemonics from "../../../../../Mnemonics.json";

const {
	formField: { name, code, companyID },
} = checkout;

const validation = [
	Yup.object().shape({
		[name.name]: Yup.string().required(name.requiredMessage),
		[code.name]: Yup.string().required(code.requiredMessage),
		[companyID.name]: Yup.object().required(companyID.requiredMessage),
	}),
];

export default validation;
